(function () {
  const badgeClass = 'paintingify-verified-badge';
  const trustMarksClass = 'paintingify-judgeme-trust-marks';
  const processedAttribute = 'data-paintingify-verified-processed';
  const authorSelectors = [
    '.jdgm-rev__author',
    '.jdgm-review-card__reviewer-name',
    '.jdgm-review-card__author',
    '[class*="reviewer-name"]',
  ];

  const reviewContainerSelectors = [
    '.jdgm-rev',
    '.jdgm-review-card',
    '.jdgm-all-reviews__review',
    '[class*="review-card"]',
  ];

  const hasVerifiedBadge = (container) => {
    if (!container) return false;

    return Boolean(
      container.querySelector(
        [
          `.${badgeClass}`,
          '.jdgm-rev__buyer-badge',
          '.jdgm-verified-badge',
          '.jdgm-badge',
          '[class*="verified"]',
        ].join(', ')
      )
    );
  };

  const createBadge = () => {
    const badge = document.createElement('span');
    badge.className = badgeClass;
    badge.textContent = 'Verified';
    badge.setAttribute('aria-label', 'Verified customer');
    return badge;
  };

  const addBadgeToAuthor = (author) => {
    if (!author || author.getAttribute(processedAttribute) === 'true') return;

    const reviewContainer = reviewContainerSelectors.reduce(
      (match, selector) => match || author.closest(selector),
      null
    );

    if (hasVerifiedBadge(reviewContainer || author.parentElement)) {
      author.setAttribute(processedAttribute, 'true');
      return;
    }

    author.insertAdjacentElement('afterend', createBadge());
    author.setAttribute(processedAttribute, 'true');
  };

  const applyVerifiedBadges = () => {
    if (!document.querySelector('.jdgm-widget, [class*="jdgm"]')) return;

    authorSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach(addBadgeToAuthor);
    });
  };

  const trustMarks = [
    { label: 'Verified', icon: 'check' },
    { label: 'Platinum Authentic Shop', icon: 'shield' },
    { label: 'Platinum Transparent Shop', icon: 'spark' },
  ];

  const createTrustIcon = (type) => {
    const namespace = 'http://www.w3.org/2000/svg';
    const icon = document.createElementNS(namespace, 'svg');
    icon.setAttribute('viewBox', '0 0 20 20');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');

    const path = document.createElementNS(namespace, 'path');
    const paths = {
      check: 'M5.25 10.25 8.5 13.5l6.25-7',
      shield: 'M10 2.5 16 5v4.4c0 3.7-2.5 6.5-6 8.1-3.5-1.6-6-4.4-6-8.1V5l6-2.5Zm-2.7 7.7 1.8 1.8 3.7-4.1',
      spark: 'M10 2.5c.7 3.8 2.2 5.3 6 6-3.8.7-5.3 2.2-6 6-.7-3.8-2.2-5.3-6-6 3.8-.7 5.3-2.2 6-6Z',
    };
    path.setAttribute('d', paths[type]);
    icon.appendChild(path);
    return icon;
  };

  const createTrustMark = ({ label, icon }) => {
    const mark = document.createElement('span');
    mark.className = `${trustMarksClass}__item`;
    mark.appendChild(createTrustIcon(icon));

    const text = document.createElement('span');
    text.textContent = label;
    mark.appendChild(text);
    return mark;
  };

  const applyTrustMarks = () => {
    document.querySelectorAll('.jdgm-review-widget, .jdgm-all-reviews-widget').forEach((widget) => {
      if (widget.querySelector(`.${trustMarksClass}`)) return;
      if (widget.querySelector('.jm-verified-badge, .jm-medals')) return;

      const summary = widget.querySelector(
        '.jdgm-rev-widg__summary, .jdgm-all-reviews__summary, .jdgm-widget-actions-wrapper'
      );
      if (!summary) return;

      const container = document.createElement('div');
      container.className = trustMarksClass;
      container.setAttribute('aria-label', 'Judge.me trust badges');
      trustMarks.forEach((mark) => container.appendChild(createTrustMark(mark)));
      summary.insertAdjacentElement('afterend', container);
    });
  };

  const injectStyles = () => {
    if (document.getElementById('paintingify-judgeme-verified-style')) return;

    const style = document.createElement('style');
    style.id = 'paintingify-judgeme-verified-style';
    style.textContent = `
      .${badgeClass} {
        display: inline-flex;
        align-items: center;
        min-height: 1.6rem;
        margin-left: 0.7rem;
        padding: 0.1rem 0.55rem;
        border-radius: 0.35rem;
        background: #ff4e2f;
        color: #fff;
        font-size: 1.1rem;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: 0;
        vertical-align: middle;
        white-space: nowrap;
      }
      .${trustMarksClass} {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 0.8rem;
        margin: 1.2rem 0 1.8rem;
      }
      .${trustMarksClass}__item {
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        min-height: 3rem;
        padding: 0.45rem 0.8rem;
        border: 1px solid rgba(148, 49, 59, 0.2);
        border-radius: 999px;
        background: #fffaf4;
        color: #5f252c;
        font-size: 1.2rem;
        font-weight: 650;
        line-height: 1.2;
        white-space: nowrap;
      }
      .${trustMarksClass}__item svg {
        width: 1.6rem;
        height: 1.6rem;
        fill: none;
        stroke: #94313b;
        stroke-width: 1.65;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
      @media screen and (max-width: 749px) {
        .${trustMarksClass} {
          justify-content: flex-start;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const init = () => {
    injectStyles();
    applyVerifiedBadges();
    applyTrustMarks();

    let updateQueued = false;
    const observer = new MutationObserver(() => {
      if (updateQueued) return;
      updateQueued = true;
      requestAnimationFrame(() => {
        applyVerifiedBadges();
        applyTrustMarks();
        updateQueued = false;
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
